import { withDisplayName } from '@hocs/with-display-name'
import { useInternalLinkProps } from '@hooks/links/use-internal-link-props'
import Button from '@ui/atoms/button'
import { graphql } from 'gatsby'
import React from 'react'

const ContentfulBlogTagButton: Utils.EntryFC<
  Queries.ContentfulBlogTagButtonFragment
> = ({
  content: { slug },
  children,
  entryInspectorProps,
  fieldInspectorProps,
}) => {
  const internalLinkProps = useInternalLinkProps(slug)

  return (
    <Button
      {...internalLinkProps}
      {...entryInspectorProps()}
      {...fieldInspectorProps({
        fieldId: 'slug',
      })}
      variant="secondary"
    >
      {children}
    </Button>
  )
}

export const query = graphql`
  fragment ContentfulBlogTagButton on ContentfulBlogTag {
    ...ContentfulEntry
    slug: getFullSlug
  }
`

export default withDisplayName(
  ContentfulBlogTagButton,
  'ContentfulBlogTagButton'
)
